exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-box[data-v-3725835f] {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
